import React from 'react';
import { GameState } from '../../../../services/api';
import SituationPlayerActing from './components/SituationPlayerActing';
import ActingPlayerView from './components/ActingPlayerView';
import SituationSelection from './components/RandomSituationSelection';

interface RoleAssignmentProps {
  gameState: GameState;
  playerId: string;
  onStateUpdate: (newState: GameState) => void;
}

const RoleAssignment: React.FC<RoleAssignmentProps> = ({ gameState, playerId, onStateUpdate }) => {
  const isSituationPlayer = gameState.currentSituationPlayer === playerId;

  return isSituationPlayer ? 
    (gameState.state === "roleAssignment" 
      ? <SituationSelection 
          gameState={gameState} 
          playerId={playerId} 
          onStateUpdate={onStateUpdate} /> 
      : <SituationPlayerActing 
          gameState={gameState} 
          playerId={playerId} 
          onStateUpdate={onStateUpdate} 
        />) 
      : <ActingPlayerView gameState={gameState} />
};

export default RoleAssignment;